export function canViewReturn(user, ownerUid) {
  return Boolean(user && typeof ownerUid === 'string' && ownerUid && user.uid === ownerUid);
}

export function signInReturnUrl(adminUrl, returnUrl) {
  const url = new URL('/index.html', adminUrl);
  url.searchParams.set('redirect_url', returnUrl);
  return url.href;
}
